export default __webpack_public_path__ + "static/invistat1-53a44299d0f7fc2b36f1ff290f2b1559.png";